export const GA_MEASUREMENT_ID = "G-5TKR4D0M5X";

// SSR-safe: `window` is only touched inside the functions, at call time.
const w = () => (typeof window !== "undefined" ? (window as any) : undefined);

export const pageview = (url: string) => {
  const win = w();
  if (!win || typeof win.gtag !== "function") return;
  win.gtag("event", "page_view", { page_path: url });
};

export const gtagEvent = (
  action: string,
  params?: Record<string, string | number | boolean>,
) => {
  const win = w();
  if (!win || typeof win.gtag !== "function") return;
  win.gtag("event", action, params);
};
